export type User = {
  email: string;
  name?: string;
  avatar?: string;
};

export enum UserRole {
  SUPER_ADMIN = 'superAdmin',
  ADMIN = 'admin',
}

export type Session = {
  user?: User | null;
  roles?: UserRole[] | null;
  /**
   * Server-evaluated LaunchDarkly flags. Most are boolean, but some carry a configuration value
   * such as `finisher-certificates-v-3-launch-date`.
   */
  featureFlags?: Record<string, boolean | string> | null;
  uuid?: string;
};
